import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SESSION_EXPIRED_EVENT } from "utils/authSession";
import { showToast } from "utils/toast";

// Sends the user to sign in when the API rejects their saved session, and
// brings them back to the same page afterwards.
const SessionExpiredRedirect = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onExpired = () => {
      if (location.pathname.startsWith("/v2/auth")) return;
      const next = encodeURIComponent(location.pathname + location.search);
      showToast.dismiss();
      showToast.error(t("auth.login.sessionExpired"), { force: true });
      navigate(`/v2/auth/login?next=${next}`, { replace: true });
    };
    window.addEventListener(SESSION_EXPIRED_EVENT, onExpired);
    return () => window.removeEventListener(SESSION_EXPIRED_EVENT, onExpired);
  }, [location, navigate, t]);

  return null;
};

export default SessionExpiredRedirect;
